import React, { useContext } from 'react';
import { getSortedArrayByValue } from 'utils/utils';
import { AssetConfigContext } from 'contexts/assetConfig.context';
import { MultiSelect } from 'components/inputs/Select/MultiSelect';
import { LabelValuePair } from 'utils/common';

type AssetSubTypeProps = {
  value: string[];
  onChange: (values: string[]) => void;
  className?: string;
};

export const MultiSelectAssetTypes = React.memo((props: AssetSubTypeProps) => {
  const { assetSubtype } = useContext(AssetConfigContext);
  const alphaSortedOptions = getSortedArrayByValue(assetSubtype, 'value')
    .map((r: LabelValuePair) => ({ key: r.label, value: r.value }));

  return (
    <MultiSelect
      label="Asset Types"
      id="asset_types_select"
      options={alphaSortedOptions}
      value={props.value}
      onChange={props.onChange}
      className={props.className}
    />
  );
});
